import {
  useScrollTracking,
  useSearchQueryFilter,
} from '@aibees/elephant/hooks';
import { Icon } from '@aibees/shared/components';
import { Box, Button } from '@mui/material';
import { memo, useRef } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ScrollableAreaProps as Props } from './types';

export const ScrollableArea = memo(({ className, children, values }: Props) => {
  const { removeParam } = useSearchQueryFilter({ select: ['value'] });

  const scrollableRef = useRef<HTMLDivElement>(null);

  const { canScrollLeft, canScrollRight } = useScrollTracking(
    scrollableRef,
    values
  );

  const handleScroll = () => {
    if (scrollableRef.current) {
      scrollableRef.current.scrollBy({ left: 211, behavior: 'smooth' });
    }
  };

  const handleScrollLeft = () => {
    if (scrollableRef.current) {
      scrollableRef.current.scrollBy({ left: -211, behavior: 'smooth' });
    }
  };

  return (
    <>
      {canScrollLeft && (
        <Styled.ScrollButtonLeft>
          <Box sx={SX.scrollBtn(canScrollLeft)} onClick={handleScrollLeft}>
            <Icon name="chevron-left" />
          </Box>
        </Styled.ScrollButtonLeft>
      )}
      <Styled.ScrollableArea ref={scrollableRef}>
        {children}
      </Styled.ScrollableArea>
      <Styled.ScrollButton>
        <Box sx={SX.scrollBtn(canScrollRight)} onClick={handleScroll}>
          <Icon name="chevron-right" />
        </Box>
        <Box
          sx={SX.removeAll(values.length)}
          onClick={() => removeParam('value')}
        >
          <Button variant="outlined" size="xsmall">
            Clear All
          </Button>
          <Icon name="close" size={16} />
        </Box>
      </Styled.ScrollButton>
    </>
  );
});

ScrollableArea.displayName = 'ScrollableArea';
